<!--
 * @Author: zuishuanicx 1342142818@qq.com
 * @Date: 2023-01-06 09:31:08
 * @LastEditors: zuishuanicx 1342142818@qq.com
 * @LastEditTime: 2023-01-06 09:56:46
 * @FilePath: \dzCloud\src\projects\tiktok\pages\batchModify\components\LeftTree.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="white-body-view">
        <el-tree
            id="my-tree"
            ref="tree"
            class="tree-view structure-tree"
            :data="treeData"
            highlight-current
            :default-expand-all="treeExpandAll"
            :props="defaultProps"
            check-strictly
            :node-key="treeNodeKey"
            :auto-expand-parent="false"
            :expand-on-click-node="false"
            :default-expanded-keys="expandDefault"
        >
            <span slot-scope="{ data }" class="custom-tree-node">
                <span class="tooltip" @click="handleMaterial(data)">
                    <span class="add-f-s-14">{{ data.name }}</span>
                </span>
            </span>
        </el-tree>
    </div>
</template>

<script>
export default {
    props: {
        // 源数据
        treeData: {
            type: Array,
            default: function () {
                return [];
            },
        },

        // 树节点是否默认展开
        treeExpandAll: {
            type: Boolean,
            default: false,
        },

        // 树节点唯一标识
        treeNodeKey: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            defaultProps: {
                children: 'children',
                label: 'name',
            },
            selectItem: {},
            expandDefault: ['0'],
        };
    },
    methods: {
        //点击
        handleMaterial(data) {
            this.$emit('handleMaterial', data);
        },
    },
};
</script>

<style lang="scss" scoped>
.structure-tree {
    .el-scrollbar .el-scrollbar__wrap {
        overflow-x: hidden;
    }
    #my-tree .el-tree > .el-tree-node {
        min-width: 100%;
        display: inline-block;
    }
    .el-tree-node__content {
        margin-bottom: 10px;
    }
    .tooltip {
        margin-right: 5px;
        font-size: 13px;
        border-radius: 4px;
        box-sizing: border-box;
        white-space: nowrap;
        padding: 4px;
    }
    .operation-view {
        display: inline-block;
        padding: 0px 5px;
        margin-left: 5px;
        color: #777777;
    }
    .small-operation-btn {
        margin: 0px 3px;
    }
}
</style>
